<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 21 20"
    fill="none"
  >
    <path
      d="M8 10L10 12L13.5 8"
      stroke="currentColor"
      stroke-width="1.4"
      stroke-linecap="round"
    />
    <path
      d="M10.5 2.36621C11.0327 2.36621 11.5582 2.53692 12.9082 2.99902L13.3857 3.16211C14.647 3.59385 15.5641 3.90775 16.207 4.16895C16.5277 4.29922 16.7576 4.40746 16.917 4.5C17.0864 4.5984 17.1203 4.64808 17.1123 4.63672C17.1069 4.62899 17.1422 4.68173 17.1797 4.87598C17.2151 5.05993 17.2427 5.31555 17.2617 5.66406C17.2997 6.36248 17.2998 7.33857 17.2998 8.67969V9.99219C17.2998 14.2584 14.1117 16.3616 11.9707 17.2969C11.6601 17.4325 11.487 17.5065 11.2949 17.5557C11.1128 17.6023 10.8877 17.6328 10.5 17.6328C10.1123 17.6328 9.88717 17.6023 9.70508 17.5557C9.51298 17.5065 9.33988 17.4325 9.0293 17.2969C6.8883 16.3616 3.70021 14.2584 3.7002 9.99219V8.67969C3.7002 7.33857 3.70025 6.36248 3.73828 5.66406C3.75726 5.31555 3.78486 5.05993 3.82031 4.87598C3.85776 4.68173 3.89313 4.62899 3.8877 4.63672C3.87972 4.64808 3.91357 4.5984 4.08301 4.5C4.2424 4.40746 4.47229 4.29922 4.79297 4.16895C5.43594 3.90775 6.35298 3.59385 7.61426 3.16211L8.0918 2.99902C9.44178 2.53692 9.96728 2.36621 10.5 2.36621Z"
      stroke="currentColor"
      stroke-width="1.4"
    />
  </svg>
</template>
